import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useActiveColorScheme } from "@m/alchemy-theme";
import { BellIcon } from "../icons/BellIcon";
import * as Styled from "./Alert.styled";
/* Export these levels so they can be used in the Demo without having to update in both spots */
export const ALERT_LEVELS = {
    error: "expressiveNegative",
    inactive: "expressiveNeutral",
    informative: "expressiveInformative",
    negative: "expressiveNegative",
    neutral: "expressiveWarning",
    positive: "expressivePositive",
    service: "expressiveWarning",
    warning: "expressiveWarning"
};
export const Alert = forwardRef((props, ref) => {
    const { attached = "none", children, icon, level = "informative", shouldWrapContent, size = "large", status, value, ...otherProps } = props;
    const currentPalette = ALERT_LEVELS[level];
    const activeColorScheme = useActiveColorScheme();
    const textContent = (_jsx(Styled.AlertText, { size: size, activeColorScheme: activeColorScheme, children: value || children }));
    return (_jsxs(Styled.Alert, { ref: ref, palette: currentPalette, attached: attached, size: size, shouldWrapContent: shouldWrapContent, "data-testid": "Alert", ...otherProps, children: [icon ? (icon) : (_jsx(Styled.AlertIconWrapper, { size: size, palette: currentPalette, activeColorScheme: activeColorScheme, children: _jsx(BellIcon, { palette: currentPalette, color: "container", size: size === "extraSmall" ? 10 : size === "small" ? 12 : 16, "aria-hidden": "true" }) })), size === "large" && textContent, 
            // If alert is size small, text is rendered in status block
            // Make sure to show text even if status not supplied (originally had to show both)
            (status || value || children) && (
            // Render status and if small render status and text - normal text position will be hidden
            _jsxs(Styled.AlertStatus, { size: size, activeColorScheme: activeColorScheme, children: [status, size !== "large" && (value || children) && textContent] }))] }));
});
Alert.displayName = "Alert";
Alert.defaultProps = {
    attached: "none",
    level: "informative",
    shouldWrapContent: false,
    size: "large",
    status: ""
};
